import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import Rating from "@mui/material/Rating";

function WhatPeopleSay() {
  var settings = {
    dots: false,
    infinite: true,
    autoplay: false,
    arrow: true,
    centerMode: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    centerPadding: "20px",
    slidesToScroll: 1,
    initialSlide: 0,
    prevArrow: <BsChevronLeft />,
    nextArrow: <BsChevronRight />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    beforeChange: (current, next) => {
      document
        .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
        .forEach(el => el.setAttribute('tabindex', '-1'));
    },
    afterChange: () => {
      document
        .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
        .forEach(el => el.removeAttribute('tabindex'));
    }
  };

  return (
    <>
      <section className="Lt_testimonials_section">
        <div className="container">
          <div className="Lt_title_text">
            <h2>What People Say</h2>
          </div>

          <div className="slider-wrapper">
            <Tabs
              defaultActiveKey="google"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="google" title="">
                <div className="Lt_people_content_main">
                  <Slider {...settings}>
                    <div className="Lt_people_item">
                      <p className="desc ">
                        “I have been impressed with personalized attention and
                        care for their “clients”. You feel like you become a
                        part of this family the first time you walk through
                        their door. And I have been impres
                        <Link
                          to="#"
                          target="_blank"
                          className="review_read_more"
                        >
                          Read more...
                        </Link>
                        <div className="Lt_peope_rating">
                          <Rating name="read-only" value={5} readOnly />
                        </div>
                      </p>

                      <h3 className="title18">
                        <Link to="#" className="txt-black">
                          Katie M.
                        </Link>
                      </h3>
                    </div>

                    <div className="Lt_people_item">
                      <p className="desc ">
                        I've been a customer of Precious Diamonds for many years
                        and I've been very happy with them. They have a wide
                        selection of high quality items and if I ever need
                        anything, they are more than willing to
                        <Link
                          to="#"
                          target="_blank"
                          className="review_read_more"
                        >
                          Read more...
                        </Link>
                        <div className="Lt_peope_rating">
                          <Rating name="read-only" value={5} readOnly />
                        </div>
                      </p>

                      <h3 className="title18">
                        <Link to="#" className="txt-black">
                          Karen U.
                        </Link>
                      </h3>
                    </div>

                    <div className="Lt_people_item">
                      <p className="desc ">
                        Every experience that I’ve had with Precious has been an
                        exceptional one. She and her staff are extremely
                        knowledgeable and helpful. Whenever I am looking to
                        purchase jewelry and (including custom j
                        <Link
                          to="#"
                          target="_blank"
                          className="review_read_more"
                        >
                          Read more...
                        </Link>
                        <div className="Lt_peope_rating">
                          <Rating name="read-only" value={5} readOnly />
                        </div>
                      </p>

                      <h3 className="title18">
                        <Link to="#" className="txt-black">
                          Jessie H.
                        </Link>
                      </h3>
                    </div>
                  </Slider>
                </div>
              </Tab>
              <Tab eventKey="yelp" title="">
                <div className="Lt_people_content_main">
                  <div className="Lt_people_item">
                    <p className="desc ">
                      I've been a customer of Precious Diamonds for many years
                      and I've been very happy with them. They have a wide
                      selection of high quality items and if I ever need
                      anything, they are more than willing to
                      <Link to="#" target="_blank" className="review_read_more">
                        Read more...
                      </Link>
                      <div className="Lt_peope_rating">
                        <Rating name="read-only" value={5} readOnly />
                      </div>
                    </p>

                    <h3 className="title18">
                      <Link to="#" className="txt-black">
                        Karen U.
                      </Link>
                    </h3>
                  </div>
                </div>
              </Tab>

              <Tab eventKey="ivouch" title="">
                <div className="Lt_people_content_main">
                <div className="Lt_people_item">
                      <p className="desc ">
                        Every experience that I’ve had with Precious has been an
                        exceptional one. She and her staff are extremely
                        knowledgeable and helpful. Whenever I am looking to
                        purchase jewelry and (including custom j
                        <Link
                          to="#"
                          target="_blank"
                          className="review_read_more"
                        >
                          Read more...
                        </Link>
                        <div className="Lt_peope_rating">
                          <Rating name="read-only" value={5} readOnly />
                        </div>
                      </p>

                      <h3 className="title18">
                        <Link to="#" className="txt-black">
                          Jessie H.
                        </Link>
                      </h3>
                    </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </section>
    </>
  );
}

export default WhatPeopleSay;
